import {RichText, Text, type TextProps} from '@smart/web-components';
import * as React from 'react';
import styles from './learn-more-text.module.scss';
import {RichtextLink, type RichtextLinkProps} from './richtext-link';

export interface LearnMoreTextProps {
  readonly text: string;
  readonly noMargin?: boolean;
}

export function LearnMoreText({
  text,
  noMargin,
}: LearnMoreTextProps): JSX.Element {
  return (
    <RichText
      className={`${styles.learnMoreText}${
        noMargin ? ` ${styles.noMargin}` : ``
      }`}
      mdString={text}
      customOverrides={{
        p: {
          component: Text,
          props: {
            variant: `paragraph-100`,
            className: styles.paragraph,
          } satisfies TextProps,
        },
        a: {
          component: RichtextLink,
          props: {
            variant: `hyperlink-100`,
          } satisfies Partial<RichtextLinkProps>,
        },
      }}
    />
  );
}
